<template>
  <div ref="container">
    <Label :html-for="id" bold v-if="label" :style="labelStyle">
      {{ label }}
    </Label>
    <template v-if="busca">
      <vSelect
        :label="labelBusca"
        :ref="refBusca"
        :options="options"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        @open="handleOpen"
        @input="handleChange"
      >
        <template slot="option" slot-scope="option">
          <slot name="options" :data="option"></slot>
        </template>
        <template slot="selected-option" slot-scope="option">
          <slot name="selected" :data="option"></slot>
        </template>
      </vSelect>
    </template>
    <template v-else>
      <vSelect
        :clearable="clearable"
        :label="labelBusca"
        :ref="refBusca"
        :placeholder="placeholder"
        :options="options"
        :disabled="disabled"
        :value="value"
        :filter-by="filterBy"
        :class="descriptionClass"
        @open="handleOpen"
        @input="handleChange"
        @search="handleSearch"
      >
        <template slot="no-options" slot-scope="option">
          <slot name="no-options" :data="option"></slot>
        </template>
        <template slot="option" slot-scope="option">
          <slot name="options" :data="option"></slot>
        </template>
        <template slot="selected-option" slot-scope="option">
          <slot name="selected" :data="option"></slot>
        </template>
      </vSelect>
      <div class="input-description input-margin" v-if="description">
        {{ description }}
      </div>
    </template>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import vSelect from 'vue-select';
import Label from './Label';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'SelectWithSearch',
  components: {
    vSelect,
    Label,
  },
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    filterBy: {
      type: Function,
    },
    busca: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: null,
    },
    labelBold: {
      type: Boolean,
      default: () => false,
    },
    placeholder: {
      type: String,
    },
    labelBusca: {
      type: String,
    },
    refBusca: {
      type: String,
    },
    inputClass: {
      type: String,
    },
    change: {
      type: Function,
      required: false,
    },
    search: {
      type: Function,
      default: () => false,
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: [Object, Array, Number],
      default: () => {},
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    labelSize: {
      type: String,
      validator: () => ['small', 'default'],
      default: () => 'default',
    },
    resizeSearchField: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    resize() {
      setTimeout(() => {
        const elAutocomplete = this.$refs.container.querySelector('.v-select');
        if (elAutocomplete) {
          const elInputAutocomplete =
            elAutocomplete.querySelector('.vs__search');
          const controls = elInputAutocomplete.getAttribute('aria-controls');
          const dropMenuEl = document.querySelectorAll(`#${controls}`);
          const { width } =
            dropMenuEl[dropMenuEl.length - 1].getBoundingClientRect();
          if (width <= 230 && width >= 70) {
            dropMenuEl[dropMenuEl.length - 1].style.width = `${width + 170}px`;
          }
          if (width <= 70 && width >= 60) {
            dropMenuEl[dropMenuEl.length - 1].style.width = `${width + 20}px`;
          }
        }
      }, 50);
    },
    handleOpen() {
      if (this.resizeSearchField) {
        this.resize();
      }
    },
    handleChange(selected) {
      if (this.id !== null) {
        return this.change(selected, this.id);
      }

      return this.change(selected);
    },
    handleSearch: debounce(function handleSearch(search, loading) {
      this.search(search, loading);
    }, 700),
  },
  computed: {
    labelStyle() {
      if (this.labelSize === 'small') {
        const styles = ['font-size: 14px'];
        return styles.join(' ');
      }

      return '';
    },
    descriptionClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },
  },
};
</script>
